import aesReduxConstants from '../../constants';

const accessLogReducer = function() {
  const constants = aesReduxConstants.AFB_TOOLS;

  const defaultState = {
    appTypes: [],
    list: [],
    numResults: 0,
  };

  const reducer = function(state, action) {
    if (state === undefined) state = defaultState;

    let delta = {};
    switch (action.type) {
      case constants.GET_LOGIN_ATTEMPTS_SUCCESS:
        delta = { list: action.list, numResults: action.numResults };
        break;
      case constants.GET_APP_TYPES_SUCCESS:
        delta = { appTypes: action.list };
        break;

      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default accessLogReducer();
